<template>
  <div class="chat-page">
    <chat-widget />
  </div>
</template>

<script>
import ChatWidget from '@/components/ChatWidget.vue'

export default {
  name: 'Chat',
  components: {
    ChatWidget
  }
}
</script>

<style scoped>
.chat-page {
  min-height: 100vh;
}
</style>  